import {useContext, useEffect, useState} from "react";
import api from "services/api";
import AdminAvisoModal from './modal';
import {formatDate, formatImage, getHoje} from "components/formatos";
import config from 'config';
import {CidadeContext} from "services/cidade";
import './style.css';

function AdminAviso(){
    const [lavisos, setLAvisos] = useState([]);

    // Modal
    const [operacao, setOperacao] = useState('')
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const {cod_cidade} = useContext(CidadeContext)

    function closeAdminAvisoModal(){
        setIsOpen(false);
    }

    useEffect(()=>{
        api.get(`${config.ADM_AVISOS}?cod_cidade=${cod_cidade}`)
        .then( response => {
            setLAvisos(response.data);
        });
    },[isOpen,cod_cidade])

    function novoAviso(){
        setDados(           
            {
                "id_aviso": 0,
                "title": "",
                "body": "",
                "image": "",
                "validade": getHoje(),
                "cod_cidade": cod_cidade
            } 
        );
        setIsOpen(true);
    }

    function editarAviso(linha){
        setOperacao('UPDATE')
        setDados(linha);
        setIsOpen(true);
    }

    return (
        <div>
            <AdminAvisoModal 
                isOpen={isOpen}
                onRequestClose={closeAdminAvisoModal}                 
                operacao={operacao}
                dados={dados}
            /> 
            
            <div className="admin-header-section mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <h2 className="section-title mb-0">Gestão de Avisos Pop-up</h2>
                    <button 
                        className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2" 
                        onClick={() => novoAviso()}
                        style={{ borderRadius: '12px' }}
                    >
                        <i className="fas fa-plus"></i>
                        <span>Novo Aviso</span>
                    </button>
                </div>
            </div>

            <div className="row g-4">
                {lavisos.map((e, index) => {
                    const estaVencido = new Date(e.validade) < new Date(getHoje());
                    return (
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={`aviso-${index}`}>
                            <div className="aviso-admin-card h-100 bg-card-admin rounded-4 overflow-hidden position-relative transition-all" onClick={() => editarAviso(e)}>
                                <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light-subtle">
                                    <span className="text-muted small fw-bold">ID: #{e.id_aviso}</span>
                                    <span className={`badge ${estaVencido ? 'bg-danger' : 'bg-success'}`}>
                                        {estaVencido ? 'Expirado' : 'Ativo'}
                                    </span>
                                </div>
                                
                                <div className="aviso-banner-preview bg-light" style={{ height: '120px' }}>
                                    {formatImage(e.image) ? (
                                        <img src={formatImage(e.image)} alt={e.title} className="w-100 h-100 object-fit-cover" />
                                    ) : (
                                        <div className="d-flex align-items-center justify-content-center h-100 text-muted opacity-25">
                                            <i className="fas fa-bullhorn fa-2x"></i>
                                        </div>
                                    )}
                                </div>

                                <div className="p-4">
                                    <h4 className="aviso-title mb-2 text-truncate-2" title={e.title}>
                                        {e.title}
                                    </h4>
                                    <p className="text-muted small text-truncate-3 mb-3" style={{ height: '3.6rem' }}>
                                        {e.body}
                                    </p>
                                    
                                    <div className="mt-auto pt-2 border-top">
                                        <div className="d-flex align-items-center text-muted small">
                                            <i className="far fa-calendar-check me-2 text-primary"></i>
                                            <span>Válido até: <strong>{formatDate(e.validade)}</strong></span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="aviso-actions p-3 bg-light-subtle d-flex justify-content-center border-top">
                                    <button className="btn btn-outline-primary btn-sm rounded-3 px-4 w-100">
                                        <i className="fas fa-edit me-1"></i> Editar Aviso
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default AdminAviso;